import {
  IDeleteUserPortraitResponse,
  IDeleteUserPortraitRequest,
  IPostConsentResponse,
  IPostConsentRequest,
  EliminarFiltroRequest,
  GuardarFiltro,
  GuardarFiltroRequest,
  EditarFiltroRequest,
  FiltroPractica,
  GetFiltrosRequest,
  EliminarFiltro,
  EditarFiltro,
} from './types';
import fetcher, { paramsFormer } from 'utils/fetcher';
import { API_FILTROS, API_USUARIOSPERFIL, API_VALIDARFOTO, APP_CLIENT_ID, APP_CLIENT_SECRET } from 'variables';
import { ResponseFetcher } from 'utils/fetcher/types';
import {
  PerfilesUsuario,
  InfoUser,
  GetPerfilesUsuariosRequest,
  GetInfoUsersRequest,
  IGetUserPortraitResponse,
  IGetUserPortraitRequest,
  IUpdateUserPortraitResponse,
  IUpdateUserPortraitRequest,
  PerfilUsuario,
} from 'store/usuarios/types';
import { SET_LOADING_HEADER } from 'utils/fetcher/contants';

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getPerfilesUsuario
export const getPerfilesUsuarioRequest = (
  requestBody: GetPerfilesUsuariosRequest,
  token: string
): Promise<ResponseFetcher<PerfilesUsuario>> =>
  fetcher({
    url: `${API_USUARIOSPERFIL}getPerfilesUsuario?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        ...SET_LOADING_HEADER,
      },
    },
  });

  // https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getAllUsuarios
export const getAllUsuariosRequest = (
  token: string
): Promise<ResponseFetcher<PerfilUsuario[]>> =>
  fetcher({
    url: `${API_USUARIOSPERFIL}getAllUsuarios`,
    options: {
      headers: {
        ...SET_LOADING_HEADER,
      },
    },
  });





export const postUsuarioPerfilRequest = async (
  requestBody: any,
  token: string
): Promise<ResponseFetcher<any>> => {
  const res = await fetch(`${API_USUARIOSPERFIL}postUsuarioPerfil`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
       Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
    },
    body: JSON.stringify(requestBody),
  });

  return {
    ok: res.ok,
    code: res.status,
    url: res.url,
    data: null,
  };
};


export const enabledUsuariosPerfilRequest = async (
  requestBody: any,
  token: string
): Promise<ResponseFetcher<any>> => {
  const res = await fetch(`${API_USUARIOSPERFIL}enabledUsuariosPerfil`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
       Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
    },
    body: JSON.stringify(requestBody),
  });

  return {
    ok: res.ok,
    code: res.status,
    url: res.url,
    data: null,
  };
};

  export const disabledUsuarioPerfilRequest = async (
   requestBody: any,
  token: string
): Promise<ResponseFetcher<any>> => {
  const res = await fetch(`${API_USUARIOSPERFIL}disabledUsuarioPerfil`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
       Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
    },
    body: JSON.stringify(requestBody),
  });

  return {
    ok: res.ok,
    code: res.status,
    url: res.url,
    data: null,
  };
};

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getInfoUsers
export const getInfoUsersRequest = async (
  requestBody: GetInfoUsersRequest,
  token: string
): Promise<ResponseFetcher<InfoUser[]>> =>
  fetcher({
    url: `${API_USUARIOSPERFIL}getInfoUsers`,
    options: {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        ...SET_LOADING_HEADER,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getUserPortrait
export const getUserPortrait = async (
  requestBody: IGetUserPortraitRequest
): Promise<ResponseFetcher<IGetUserPortraitResponse>> =>
  fetcher({
    url: `${API_USUARIOSPERFIL}getUserPortrait?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        ...SET_LOADING_HEADER,
      },
    },
  });
// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/updateConsentimiento
export const updateConsentRequest = async (
  requestBody: IPostConsentRequest
): Promise<ResponseFetcher<IPostConsentResponse>> =>
  fetcher({
    url: `${API_VALIDARFOTO}updateConsentimiento`,
    options: {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        ...SET_LOADING_HEADER,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/updateUserPortrait
export const updateUserPortrait = async (
  requestBody: IUpdateUserPortraitRequest
): Promise<ResponseFetcher<IUpdateUserPortraitResponse>> =>
  fetcher({
    url: `${API_USUARIOSPERFIL}updateUserPortrait`,
    options: {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        ...SET_LOADING_HEADER,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/deleteUserPortrait
export const deleteUserPortrait = async (
  requestBody: IDeleteUserPortraitRequest
): Promise<ResponseFetcher<IDeleteUserPortraitResponse>> =>
  fetcher({
    url: `${API_USUARIOSPERFIL}deleteUserPortrait`,
    options: {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        ...SET_LOADING_HEADER,
      },
    },
  });

//Filtros Request
// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/getAllFiltros
export const getFiltrosRequest = async (
  requestBody: GetFiltrosRequest,
  token: string
): Promise<ResponseFetcher<FiltroPractica[]>> =>
  fetcher({
    url: `${API_FILTROS}getAllFiltrosByUser?${paramsFormer(requestBody)}`,
    options: {
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      }
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/guardarFiltro
export const guardarFiltroRequest = async (
  requestBody: GuardarFiltroRequest,
  token: string
): Promise<ResponseFetcher<GuardarFiltro>> => {

  return fetcher({
    url: `${API_FILTROS}guardarFiltro`,
    options: {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
      },
    },
  });
};

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/eliminarFiltro
export const eliminarFiltroRequest = async (
  requestBody: EliminarFiltroRequest,
  token: string
): Promise<ResponseFetcher<EliminarFiltro>> =>
  fetcher({
    url: `${API_FILTROS}eliminarFiltro`,
    options: {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });

// https://epe.api.int.sir.renfe.es/epe/catalogo-int/test-apic/editarFiltro
export const editarFiltroRequest = async (
  requestBody: EditarFiltroRequest,
  token: string
): Promise<ResponseFetcher<EditarFiltro>> =>
  fetcher({
    url: `${API_FILTROS}updateFiltro`,
    options: {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        Authorization: token,
        clientId: APP_CLIENT_ID,
        clientSecret: APP_CLIENT_SECRET,
        ...SET_LOADING_HEADER,
      },
    },
  });
